import {UserType} from '@legit.health/ui';

export default function isPractitionerType(type: string): boolean {
  return type === UserType.Practitioner;
}
